<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 4">
        <v-card-title>
          <span v-if="$vuetify.breakpoint.name === 'sm'" class="weather-forecast-title-tablet">Previsão do tempo</span>
          <span v-else class="weather-forecast-title">Previsão do tempo</span>
        </v-card-title>
        <v-card-subtitle class="mt-4">
          <span v-if="$vuetify.breakpoint.name === 'sm'" class="weather-forecast-subtitle-tablet">
            O Simepar gera previsões<br/>
            e possui sua própria<br/>
            rede de estações<br/>
            hidrometeorológicas.
          </span>
          <span v-else class="weather-forecast-subtitle">
            O Simepar gera previsões e possui<br />
            sua própria rede de estações<br />
            hidrometeorológicas.
          </span>
        </v-card-subtitle>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 8">
        <cities-search-form role="search" @result="getSearchResult"></cities-search-form>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 4">
        <card-weather-forecast
          :cityId="id"
          :item="itemsList[itemSelected]"
        ></card-weather-forecast>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12 : 8">
        <v-slide-group :show-arrows="false" v-model="itemSelected">
          <v-slide-item
            v-for="(item, index) in itemsList"
            :key="index"
            v-slot="{ active, toggle }"
          >
            <v-btn
              style="text-transform: none;font-size: 1rem"
              rounded
              outlined
              class="mr-2"
              :input-value="active"
              active-class="secondary white--text"
              @click="toggle"
              >{{ item.text }}</v-btn
            >
          </v-slide-item>
        </v-slide-group>
        <chart-weather-forecast
          :cityId="id"
          :item="itemsList[itemSelected]"
        ></chart-weather-forecast>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CitiesSearchForm from "./CitiesSearchForm";
import ChartWeatherForecast from "./ChartWeatherForecast";
import CardWeatherForecast from "./CardWeatherForecast.vue";
export default {
  name: "WeatherForecast",
  components: { ChartWeatherForecast, CitiesSearchForm, CardWeatherForecast },
  data() {
    return {
      itemSelected: 0,
      itemsList: [
        { text: "Hoje", type: "hourly" },
        { text: "Amanhã", type: "hourly" },
        { text: "15 dias", type: "daily" },
      ],
      id: 4106902,
    };
  },
  watch: {
    itemList(value) {
      if (value) {
        this.itemSelected = 0;
        this.getSearchResult(value);
      }
    },
    id(value) {
      if (value) {
        this.itemSelected = 0;
        this.getSearchResult(value);
      }
    },
  },
  methods: {
    async getSearchResult(id) {
      this.id = id;
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap');
/* @font-face {
  font-family: 'Poppins';
  src: local('Poppins'), url('../../assets/fonts/Poppins/Poppins-Light.ttf') format("truetype");
} */

@font-face {
  font-family: 'Questrial';
  src: local('Questrial'), url('../../assets/fonts/Questrial/Questrial-Regular.ttf') format("truetype");
}

.weather-forecast-title {
  width: 269px;
  height: 33px;
  left: 104px;
  top: 68px;

  font-family: "Questrial" !important;
  font-style: normal;
  font-size: 1.875rem;
  line-height: 33px;

  display: flex;
  align-items: center;

}

.weather-forecast-title-tablet {
  font-family: "Questrial" !important;
  font-style: normal;
  font-size: 1.25rem;
}

.weather-forecast-subtitle {
  width: 245px;
  height: 63px;
  left: 104px;
  top: 122px;
  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: lighter;
  font-size: 0.875rem;
  line-height: 21px;

}

.weather-forecast-subtitle-tablet {
  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: lighter;
  font-size: 0.875rem;
  line-height: 21px;

}
</style>

